import { useStore, useUpdateEffect } from '..';
import { ValidatorType, debounce, clearDebounce } from '../../common';

const useValidator = (field: string, validator: ValidatorType, action: string): void => {
	const [, dispatch] = useStore(false);

	useUpdateEffect(() => {
		const deb = debounce(onFieldValidate);
		return () => clearDebounce(deb);
	}, [field]);

	const onFieldValidate = () => {
		dispatch(action, !validator(field));
	};
};

export { useValidator };
